import * as React from "react";

interface SessionContextProps {
  sessionId: string;
  setIsAdminTheme: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SessionContext = React.createContext<SessionContextProps>({
  sessionId: "",
  setIsAdminTheme: () => {},
});
